document.addEventListener('DOMContentLoaded', function () {
  if (!document.body.classList.contains('template-product')) return;

  document.body.style.transition = 'background-color 0.3s ease';

  window.addEventListener('scroll', function () {
    const scrollProgress = Math.min(window.scrollY / 600, 1);
    const value = Math.round(255 * scrollProgress);
    document.body.style.backgroundColor = `rgb(${value}, ${value}, ${value})`;
  });

  // Başlangıç rengi siyah
  document.body.style.backgroundColor = '#000000';
});
